import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as CentersIcon } from "../icons/Maps/centers.svg";
import { ReactComponent as PartnershipIcon } from "../icons/Maps/partnership.svg";
import { ReactComponent as FireIcon } from "../icons/Maps/fire.svg";
import { ReactComponent as FloodIcon } from "../icons/Maps/flood.svg";
import { ReactComponent as EarthquakeIcon } from "../icons/Maps/Earthquake.svg";
import { ReactComponent as HurricaneIcon } from "../icons/Maps/hurricane.svg";
import { ReactComponent as TornadoIcon } from "../icons/Maps/tornado.svg";
import {
  Map as VISGoogleMap,
  APIProvider,
  AdvancedMarker,
  Marker,
  useMap,
} from "@vis.gl/react-google-maps";
import { db, auth } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  query,
  where,
  getDoc,
} from "firebase/firestore";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import citizenProfileService from "../service/citizen/CitizenProfile";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { config } from "../utils/config";
import { useAuth } from "../components/AuthContext";
import { useNavigate } from "react-router-dom";
import handshake from "../assets/handshake.svg";
import citizenmarkernew from "../assets/citizenmarkernew.svg";
import centermarkernew from "../assets/centermarkernew.svg";
import partnermarkernew from "../assets/partnermarkernew.svg";
import ownmarker from "../assets/ownmarker.svg";
import citizenown from "../assets/citizenown.svg";
import partnerown from "../assets/partnerown.svg";
import centerown from "../assets/centerown.svg";
import { collectionGroup } from "firebase/firestore";
import { role } from "../components/AuthContext";

const CustomMarkerWithLabel = ({
  position,
  icon,
  label,
  role,
  onMouseOver,
  onMouseOut,
}) => {
  const [markerRef, setMarkerRef] = useState(null);
  const mapRef = useMap();

  useEffect(() => {
    if (!mapRef) return;
    //console.log("Creating overlay with:", { position, icon, label }); // Debug log

    const overlay = new window.google.maps.OverlayView();

    overlay.onAdd = function () {
      const div = document.createElement("div");
      div.style.position = "absolute";
      div.className = "custom-marker-container";

      // Create marker element
      const markerDiv = document.createElement("div");
      markerDiv.className = "marker";
      markerDiv.style.width = "35px";
      markerDiv.style.height = "35px";
      markerDiv.style.backgroundImage = `url(${icon?.url || ""})`;
      markerDiv.style.backgroundSize = "35px 35px";
      markerDiv.style.backgroundPosition = "center";
      markerDiv.style.backgroundRepeat = "no-repeat";
      markerDiv.style.position = "absolute";
      markerDiv.style.cursor = "pointer";

      // Create label element
      const labelDiv = document.createElement("div");
      labelDiv.className = "marker-label";
      labelDiv.innerHTML = label || "";
      labelDiv.style.position = "absolute";
      labelDiv.style.left = "40px";
      labelDiv.style.top = "50%";
      labelDiv.style.transform = "translateY(-0%)";
      labelDiv.style.background = "rgba(255, 255, 255, 0.95)";
      labelDiv.style.padding = "6px 12px";
      labelDiv.style.borderRadius = "6px";
      labelDiv.style.boxShadow = "0 8px 20px rgba(0,0,0,0.4)";
      labelDiv.style.fontSize = "16px";
      labelDiv.style.fontWeight = "600";
      labelDiv.style.color = "#1A202C";
      labelDiv.style.textTransform = "capitalize";
      labelDiv.style.letterSpacing = "0.2px";
      labelDiv.style.whiteSpace = "nowrap";
      labelDiv.style.zIndex = "1000";
      labelDiv.style.pointerEvents = "none";

      div.appendChild(markerDiv);
      if (role !== "citizen") {
        div.appendChild(labelDiv);
      }

      if (onMouseOver) {
        div.addEventListener("mouseover", (e) => {
          // Create a custom event object with the marker's position
          const markerRect = div.getBoundingClientRect();
          const customEvent = {
            domEvent: {
              target: div,
              clientX: markerRect.left + markerRect.width / 2,
              clientY: markerRect.top,
            },
            latLng: new window.google.maps.LatLng(position.lat, position.lng),
          };
          onMouseOver(customEvent);
        });
      }
      if (onMouseOut) {
        div.addEventListener("mouseout", onMouseOut);
      }

      this.div = div;
      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(div);
    };

    overlay.draw = function () {
      if (!this.div) return;

      const projection = this.getProjection();
      if (!projection) return;

      const pos = projection.fromLatLngToDivPixel(
        new window.google.maps.LatLng(position.lat, position.lng)
      );

      if (pos) {
        this.div.style.left = pos.x - 17 + "px";
        this.div.style.top = pos.y - 34 + "px";
      }
    };

    overlay.onRemove = function () {
      if (this.div) {
        if (this.div.parentNode) {
          this.div.parentNode.removeChild(this.div);
        }
        delete this.div;
      }
    };

    overlay.setMap(mapRef);
    setMarkerRef(overlay);

    return () => {
      if (overlay) {
        overlay.setMap(null);
      }
    };
  }, [mapRef, position, icon, label, onMouseOver, onMouseOut]);

  return null;
};

// Add this new component above the Map component
const StreetViewMarker = ({
  position,
  icon,
  label,
  onMouseOver,
  onMouseOut,
  role,
}) => {
  return (
    <CustomMarkerWithLabel
      position={position}
      icon={icon}
      label={label}
      role={role}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      style={{
        zIndex: 1000, // Ensure markers stay above Street View
      }}
    >
      <div
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        style={{
          cursor: "pointer",
          position: "relative",
        }}
      >
        <img
          src={icon}
          alt={`${role} marker`}
          style={{
            width: "40px",
            height: "40px",
          }}
        />
        {label && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              whiteSpace: "nowrap",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              padding: "2px 4px",
              borderRadius: "4px",
              fontSize: "12px",
              marginTop: "2px",
            }}
          >
            {label}
          </div>
        )}
      </div>
    </CustomMarkerWithLabel>
  );
};

const Map = (className = "") => {
  const [userId, setUserId] = useState(null);
  const [data, setData] = useState(null);
  const [coordinates, setCoordinates] = useState(null);
  const [communityContacts, setCommunityContacts] = useState([]);
  const [partnerAreaServiced, setpartnerAreaServiced] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const mapRef = useRef(null);
  const [permanentInfo, setPermanentInfo] = useState(null);
  const [labelText, setLabelText] = useState("");
  const [relatedUsers, setRelatedUsers] = useState([]);
  const [hoveredMarker, setHoveredMarker] = useState(null);
  const { role } = useAuth();
  const [centerId, setCenterId] = useState(null);
  const [showSidePanel, setShowSidePanel] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [showCommunityContacts, setShowCommunityContacts] = useState(true);
  const [mousePosition, setMousePosition] = useState(null);
  const [isHoveringInfo, setIsHoveringInfo] = useState(false);
  const [hideTimeout, setHideTimeout] = useState(null);
  const hoverDelay = 100; // Reduced delay for more responsive feel
  const [showAllDonations, setShowAllDonations] = useState(false);
  const [showAllItems, setShowAllItems] = useState(false);
  const [showAllServices, setShowAllServices] = useState(false);
  const [needsExpansion, setNeedsExpansion] = useState({
    donations: false,
    items: false,
    services: false,
  });

  // Add these refs at the beginning of your component
  const donationTypesRef = useRef(null);
  const availableItemsRef = useRef(null);
  const servicesProvidedRef = useRef(null);

  const [markerDataCache, setMarkerDataCache] = useState({});

  // Keep the expandedSections state
  const [expandedSections, setExpandedSections] = useState({
    donations: {},
    items: {},
    services: {},
  });

  const selectedUserId = sessionStorage.getItem("userId");

  const fetchData = async () => {
    let profileData;
    const data = await citizenProfileService.getCitizenProfile(
      "users",
      selectedUserId
    );
    setCenterId(data.center_id);
    if (role === "center") {
      profileData = await citizenProfileService.getCitizenProfile(
        "centers",
        data.center_id
      );
      setLabelText(profileData.name_of_hub || "");
    } else if (role === "partner") {
      profileData = await citizenProfileService.getCitizenProfile(
        "partners",
        data.partner_id
      );
      setLabelText(profileData.name_of_org || "");
    } else {
      profileData = await citizenProfileService.getCitizenProfile(
        "users",
        selectedUserId
      );
      setLabelText("");

      setUserRole(role);
    }

    if (profileData) {
      setData(profileData);

      // if (profileData.latitude && profileData.longitude) {
      //   const newCoordinates = {
      //     lat: profileData.latitude,
      //     lon: profileData.longitude,
      //   };
      //   setCoordinates(newCoordinates);
      //   setPermanentInfo({
      //     mobileNumber: profileData.mobile_number,
      //     address: `${profileData.address1}, ${profileData.city}, ${profileData.state}, ${profileData.zip}`,
      //     role: role,
      //   });
      // } else {
      try {
        const address = `${profileData.address1}, ${profileData.city}, ${profileData.state}, ${profileData.zip}`;
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            address
          )}&key=${config.google_maps}`
        );
        const data = await response.json();

        if (data.results.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;
          setCoordinates({ lat, lon: lng });

          let updateId =
            role === "center"
              ? profileData.id
              : role === "partner"
              ? profileData.id
              : userId;

          await citizenProfileService.updateCitizenProfile(
            role === "center"
              ? "centers"
              : role === "partner"
              ? "partners"
              : "users",
            updateId,
            {
              latitude: lat,
              longitude: lng,
            }
          );
        } else {
          throw new Error("No results found");
        }
      } catch (err) {
        setShowPopup(true);
      }
    }
    if (profileData.center_id && role === "citizen") {
      await fetchUsersWithCenterId(profileData.center_id);
    } else if (role === "center") {
      await fetchUsersWithCenterId(profileData.id);
    } else if (role === "partner") {
      const partnerRef = await citizenProfileService.getCitizenProfile(
        "users",
        userId
      );
      await fetchUsersWithCenterId(partnerRef.center_id);
    }

    if (mapRef.current) {
      if (coordinates) {
        mapRef.current.setCenter({
          lat: coordinates.lat,
          lng: coordinates.lon,
        });
      }
    }
  };

  const fetchUsersWithCenterId = async (center_id) => {
    try {
      let centerIdArray = Array.isArray(center_id) ? center_id : [center_id];

      // Query citizens (with string center_id) - only if not a partner
      const citizensQuery =
        role !== "partner"
          ? query(
              collection(db, "users"),
              where("user_role", "==", "citizen"),
              where("center_id", "in", centerIdArray)
            )
          : null;

      // Query partners (with array center_id)
      const partnersQuery = query(
        collection(db, "users"),
        where("user_role", "==", "partner"),
        where("center_id", "array-contains-any", centerIdArray)
      );

      // Get both citizens and partners data
      const [citizensSnapshot, partnersSnapshot] = await Promise.all([
        citizensQuery ? getDocs(citizensQuery) : Promise.resolve(null),
        getDocs(partnersQuery),
      ]);

      // Track needed partner document IDs
      const neededPartnerIds = new Set();
      partnersSnapshot.docs.forEach((doc) => {
        const data = doc.data();
        if (data.partner_id) {
          neededPartnerIds.add(data.partner_id);
        }
      });

      // Fetch only needed centers and partner documents with certification check
      const [centersSnapshot, partnerDocsSnapshot] = await Promise.all([
        Promise.all(
          centerIdArray.map(async (id) => {
            const centerDoc = await getDoc(doc(db, "centers", id));
            // Only return if center exists and is certified
            return centerDoc.exists() && centerDoc.data().is_certified === true
              ? centerDoc
              : null;
          })
        ),
        neededPartnerIds.size > 0
          ? Promise.all(
              [...neededPartnerIds].map(async (id) => {
                const partnerDoc = await getDoc(doc(db, "partners", id));
                // Only return if partner exists and is certified
                return partnerDoc.exists() &&
                  partnerDoc.data().is_certified === true
                  ? partnerDoc
                  : null;
              })
            )
          : [],
      ]);

      // Create indices for faster lookups, filtering out null values from uncertified entities
      const centersById = Object.fromEntries(
        centersSnapshot
          .filter((doc) => doc !== null && doc.exists())
          .map((doc) => [doc.id, { id: doc.id, ...doc.data() }])
      );

      const partnersById = Object.fromEntries(
        partnerDocsSnapshot
          .filter((doc) => doc !== null && doc.exists())
          .map((doc) => [doc.id, { id: doc.id, ...doc.data() }])
      );

      // Process and filter markers
      const relatedUsersData = [];

      // Add the certified centers data
      Object.values(centersById).forEach((centerData) => {
        relatedUsersData.push(centerData);
      });

      // Process certified partners
      partnersSnapshot.docs.forEach((doc) => {
        const data = doc.data();
        if (data.partner_id && partnersById[data.partner_id]) {
          relatedUsersData.push(partnersById[data.partner_id]);
        }
      });

      // Process citizens (no certification check needed) - only if not a partner
      if (citizensSnapshot && role !== "partner") {
        citizensSnapshot.docs.forEach((doc) => {
          const data = doc.data();
          if (role === "citizen") {
            if (data.citizen_id === userId) {
              relatedUsersData.push({ id: doc.id, ...data });
            }
          } else {
            relatedUsersData.push({ id: doc.id, ...data });
          }
        });
      }

      // Add debug logging
      console.debug(`Fetching users for role: ${role}`);
      console.debug(`Total related users found: ${relatedUsersData.length}`);
      console.debug(
        "User types:",
        relatedUsersData.map((user) => user.user_role || user.userType)
      );

      // Cache the results
      const cacheKey = centerIdArray.sort().join(",");
      setMarkerDataCache((prev) => ({
        ...prev,
        [cacheKey]: relatedUsersData,
      }));
      setRelatedUsers(relatedUsersData);
    } catch (error) {
      console.error("Error fetching related users:", error);
    }
  };

  // Fetch all community contacts from Firestore
  const fetchCommunityContacts = async () => {
    // Early return if no role is defined
    if (!role) {
      return;
    }

    let contactsQuery;
    const auth = getAuth();
    const selectedUserId = sessionStorage.getItem("userId");
    const uid = selectedUserId ? selectedUserId : "";

    // Early return if no uid for center role
    if (role === "center" && !uid) {
      return;
    }

    // Early return if no centerId for citizen role
    if (role === "citizen" && !centerId) {
      return;
    }

    try {
      if (role === "citizen") {
        // Fetch the center doc id using the citizen's center_id
        const userQuery = query(
          collection(db, "users"),
          where("user_role", "==", "center"),
          where("center_id", "==", centerId)
        );
        const userSnapshot = await getDocs(userQuery);

        // Only proceed if we found a matching center
        if (!userSnapshot.empty) {
          const userDoc = userSnapshot.docs[0];
          const docId = userDoc.id;

          // Fetch the community contacts for the center using the docId
          contactsQuery = query(
            collection(db, "community-contacts"),
            where("is_deleted", "==", false),
            where("user_id", "==", docId)
          );
        } else {
          return;
        }
      } else if (role === "center") {
        contactsQuery = query(
          collection(db, "community-contacts"),
          where("is_deleted", "==", false),
          where("user_id", "==", uid)
        );
      } else if (role === "partner") {
        // Fetch the center docs using the array of center_ids
        const centerQueries = centerId.map(async (id) => {
          const userQuery = query(
            collection(db, "users"),
            where("user_role", "==", "center"),
            where("center_id", "==", id)
          );
          return getDocs(userQuery);
        });

        const centerSnapshots = await Promise.all(centerQueries);
        const centerDocIds = [];

        // Get all center doc IDs
        centerSnapshots.forEach((snapshot) => {
          if (!snapshot.empty) {
            centerDocIds.push(snapshot.docs[0].id);
          }
        });

        if (centerDocIds.length > 0) {
          // Fetch community contacts for all centers
          contactsQuery = query(
            collection(db, "community-contacts"),
            where("is_deleted", "==", false),
            where("user_id", "in", centerDocIds)
          );
        } else {
          return;
        }
      } else {
        return;
      }

      // Only proceed if we have a valid query
      if (!contactsQuery) {
        return;
      }

      const contactsSnapshot = await getDocs(contactsQuery);

      const contacts = contactsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const updatedContacts = await Promise.all(
        contacts.map(async (contact) => {
          if (contact.latitude && contact.longitude) {
            return contact;
          } else {
            try {
              const address = `${contact.address1}, ${contact.city}, ${contact.state}, ${contact.zip}`;
              const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
                  address
                )}&key=${config.google_maps}`
              );
              const data = await response.json();
              if (data.results.length > 0) {
                const { lat, lng } = data.results[0].geometry.location;
                const contactRef = doc(db, "community-contacts", contact.id);
                await updateDoc(contactRef, {
                  latitude: lat,
                  longitude: lng,
                });

                return { ...contact, latitude: lat, longitude: lng };
              } else {
                throw new Error("No results found for address");
              }
            } catch (err) {
              console.error(
                "Error fetching coordinates for contact:",
                contact.id,
                err
              );
              setShowPopup(true);
              return contact;
            }
          }
        })
      );

      setCommunityContacts(
        updatedContacts.filter(
          (contact) => contact.latitude && contact.longitude
        )
      );
    } catch (error) {
      console.error("Error in fetchCommunityContacts:", error);
    }
  };

  const fetchPartnersByCounty = async () => {
    try {
      const partnerQuery = query(
        collection(db, "partners"),
        where("area_serviced_county", "array-contains", data.county)
      );

      const partnersSnapshot = await getDocs(partnerQuery);
      const partners = partnersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setpartnerAreaServiced(partners);
    } catch (error) {
      console.error("Error fetching partners by county:", error);
    }
  };

  const handleMapLoad = (map) => {
    mapRef.current = map;
  };

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUserId(selectedUserId);
      } else {
        setData(null);
        console.log("No user is logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (userId && role) {
      fetchData();
    }
  }, [userId, role]);

  useEffect(() => {
    if (userId && role && centerId && data) {
      if (role === "citizen") {
        fetchPartnersByCounty();
      }
    }
  }, [userId, role, centerId, data]);

  useEffect(() => {
    if (userId && role && centerId) {
      fetchCommunityContacts();
    }
  }, [userId, role, centerId]);

  useEffect(() => {
    // Only set map center if coordinates are available
    if (mapRef.current && coordinates) {
      mapRef.current.setCenter({
        lat: coordinates.lat,
        lng: coordinates.lon,
      });
    }
  }, [coordinates]);

  // useEffect(() => {
  //   if (mapRef.current) {
  //     if (coordinates) {
  //       mapRef.current.setCenter({
  //         lat: coordinates.lat,
  //         lng: coordinates.lon,
  //       });
  //       mapRef.current.setZoom(15);
  //     }
  //   }
  // }, [coordinates]);

  // Determine marker color based on user_role
  const getMarkerColor = (role) => {
    switch (role) {
      case "center":
        return "green";
      case "partner":
        return "yellow";
      case "citizen":
        return "blue";
      case "community-contact":
        return "pink";
      default:
        return "red";
    }
  };

  const getMarkerImage = (passedRole, isCurrentUser) => {
    // Always use ownmarker for the current user, regardless of role
    if (isCurrentUser || role === userId) {
      return {
        url:
          role === "citizen"
            ? citizenown
            : role === "partner"
            ? partnerown
            : centerown,
        scaledSize: new window.google.maps.Size(65, 65), // Increased from 50 to 65
        labelOrigin: new window.google.maps.Point(17, -10),
      };
    }

    // For other users, use role-specific markers
    let markerUrl;
    switch (passedRole) {
      case "center":
        markerUrl = centermarkernew;
        break;
      case "partner":
        markerUrl = partnermarkernew;
        break;
      case "citizen":
        markerUrl = citizenmarkernew;
        break;
      default:
        markerUrl = ownmarker;
    }
    return {
      url: markerUrl,
      scaledSize: new window.google.maps.Size(35, 35),
      labelOrigin: new window.google.maps.Point(17, -10),
    };
  };

  const handleMarkerHover = (markerData, event) => {
    setHoveredMarker(markerData);
    if (event && event.domEvent) {
      setMousePosition({
        x: event.domEvent.clientX,
        y: event.domEvent.clientY,
      });
    }
  };

  const handleMarkerLeave = () => {
    // Simple timeout to allow moving to info window
    const timeout = setTimeout(() => {
      setHoveredMarker(null);
      setMousePosition(null);
    }, 300); // Increased timeout for better usability
    setHideTimeout(timeout);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const renderMarkerInfo = () => {
    if (!hoveredMarker) return null;

    let role =
      hoveredMarker.userType.toLowerCase() ||
      hoveredMarker.user_role.toLowerCase();

    // Display different information based on the type of marker hovered
    if (role === "center") {
      const fullAddress = `${hoveredMarker.address1 || ""} ${
        hoveredMarker.address2 || ""
      }, ${hoveredMarker.city || ""}, ${hoveredMarker.state || ""} ${
        hoveredMarker.zip || ""
      }`;
      return (
        <div
          className="flex flex-col gap-2 rounded-lg px-4 py-4"
          style={{ background: "white" }}
        >
          <div className="flex flex-col gap-2">
            <div className="flex flex-col gap-1 rounded-lg bg-[#003460] p-2">
              <h3 className="text-lg rounded-lg text-start font-semibold text-white">
                {hoveredMarker.name_of_hub || ""}
              </h3>
              <p className="mb-2 text-start text-[#DCDCDC]">Center</p>
              <div className="text-gray-600 flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="#F6C46D"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-[#DCDCDC]">{fullAddress || ""}</span>
              </div>
              {hoveredMarker.contact_email && (
                <div className="text-gray-600 flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="#F6C46D"
                  >
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <span className="text-[#DCDCDC]">
                    {hoveredMarker.contact_email || ""}
                  </span>
                </div>
              )}
              {hoveredMarker.contact_phone && (
                <div className="text-gray-600 flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="#F6C46D"
                  >
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <span className="text-[#DCDCDC]">
                    {hoveredMarker.contact_phone || ""}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    } else if (role === "partner") {
      const fullAddress = `${hoveredMarker.address1 || ""} ${
        hoveredMarker.address2 || ""
      }, ${hoveredMarker.city || ""}, ${hoveredMarker.state || ""} ${
        hoveredMarker.zip || ""
      }`;
      return (
        <div
          className="flex flex-col gap-1 px-4 py-4"
          style={{ background: "white" }}
        >
          <div className="flex flex-col gap-1">
            <div className="flex flex-col gap-1 rounded-lg bg-[#003460] p-2">
              <div className="flex justify-between">
                <div className="flex flex-col gap-1">
                  <h3 className="text-lg text-start font-bold text-white ">
                    {hoveredMarker.name_of_org || ""}
                  </h3>
                  <p className="mb-2 text-start text-[#DCDCDC]">Partner</p>
                </div>
                <img
                  src={handshake}
                  alt="handshake"
                  className="absolute right-0 top-6 mr-16 h-16 w-16"
                />
              </div>

              <div className="flex justify-between ">
                <div className="flex flex-col gap-1">
                  <div className="text-gray-600 flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="#F6C46D"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="text-[#DCDCDC]">{fullAddress || ""}</span>
                  </div>
                  {hoveredMarker.contact_email && (
                    <div className="text-gray-600 flex items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="#F6C46D"
                      >
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                      <span className="text-[#DCDCDC]">
                        {hoveredMarker.contact_email || ""}
                      </span>
                    </div>
                  )}
                  {hoveredMarker.contact_phone && (
                    <div className="text-gray-600 flex items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="#F6C46D"
                      >
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                      </svg>
                      <span className="text-[#DCDCDC]">
                        {hoveredMarker.contact_phone || ""}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-1 rounded-lg bg-[#D3EBFF] p-1">
            <div className="rounded-lg  p-1">
              <h4 className="mb-2 font-semibold text-[#003460]">
                Donations Accepted
              </h4>
              <div className="mx-auto">
                <div
                  ref={donationTypesRef}
                  className={`flex flex-wrap gap-x-1 gap-y-2 ${
                    !showAllDonations && "max-h-[64px] overflow-hidden"
                  }`}
                >
                  {hoveredMarker.donation_types &&
                  hoveredMarker.accept_donations == "yes" ? (
                    hoveredMarker.donation_types.map((type) => (
                      <div key={type} className="flex justify-center">
                        <span className="my-auto block min-w-fit whitespace-nowrap rounded-full border-[0.5px] border-solid border-[#9D0F0F] bg-[#FFF3F3] px-3 py-1 text-center text-sm text-[#9D0F0F]">
                          {type === "other"
                            ? hoveredMarker.other_donation_types || "Other"
                            : type.charAt(0).toUpperCase() + type.slice(1)}
                        </span>
                      </div>
                    ))
                  ) : (
                    <span className="text-gray-500"></span>
                  )}
                </div>
                {needsExpansion.donations && (
                  <button
                    onClick={() => setShowAllDonations(!showAllDonations)}
                    className="mt-2 bg-transparent text-base font-normal  text-[#8B2323] hover:cursor-pointer"
                  >
                    {showAllDonations ? "See less" : "See more"}
                  </button>
                )}
              </div>
            </div>

            <div className="rounded-lg p-1">
              <h4 className="mb-2 font-semibold text-[#003460]">
                Available Items
              </h4>
              <div className="mx-auto">
                <div
                  ref={availableItemsRef}
                  className={`flex flex-wrap gap-x-1 gap-y-2 ${
                    !showAllItems && "max-h-[64px] overflow-hidden"
                  }`}
                >
                  {hoveredMarker.available_items &&
                  hoveredMarker.available_items.length > 0 ? (
                    hoveredMarker.available_items.map((type) => (
                      <div key={type} className="flex justify-center">
                        <span className="my-auto block min-w-fit whitespace-nowrap rounded-full border-[0.5px] border-solid border-[#9D0F0F] bg-[#FFF3F3] px-3 py-1 text-center text-sm text-[#9D0F0F]">
                          {type === "other"
                            ? hoveredMarker.other_donation_types || ""
                            : type.charAt(0).toUpperCase() + type.slice(1)}
                        </span>
                      </div>
                    ))
                  ) : (
                    <span className="text-gray-500"></span>
                  )}
                </div>
                {needsExpansion.items && (
                  <button
                    onClick={() => setShowAllItems(!showAllItems)}
                    className="mt-2 bg-transparent text-base font-normal  text-[#8B2323] hover:cursor-pointer"
                  >
                    {showAllItems ? "See less" : "See more"}
                  </button>
                )}
              </div>
            </div>

            <div className="rounded-lg p-1">
              <h4 className="mb-2 font-semibold text-[#003460]">
                Services Provided
              </h4>
              <div className="mx-auto">
                <div
                  ref={servicesProvidedRef}
                  className={`flex flex-wrap gap-x-1 gap-y-2 ${
                    !showAllServices && "max-h-[64px] overflow-hidden"
                  }`}
                >
                  {hoveredMarker.servicesProvided &&
                  hoveredMarker.servicesProvided.length > 0 ? (
                    hoveredMarker.servicesProvided.map((service) => (
                      <div key={service} className="flex justify-center">
                        <span className="my-auto block min-w-fit whitespace-nowrap rounded-full border-[0.5px] border-solid border-[#9D0F0F] bg-[#FFF3F3] px-3 py-1 text-center text-sm text-[#9D0F0F]">
                          {service === "other"
                            ? hoveredMarker.other_services || "Other"
                            : service.charAt(0).toUpperCase() +
                              service.slice(1)}
                        </span>
                      </div>
                    ))
                  ) : (
                    <span className="text-gray-500"></span>
                  )}
                </div>
                {needsExpansion.services && (
                  <button
                    onClick={() => setShowAllServices(!showAllServices)}
                    className="mt-2 bg-transparent text-base font-normal  text-[#8B2323] hover:cursor-pointer"
                  >
                    {showAllServices ? "See less" : "See more"}
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-1">
            <h4 className="mb-2 font-bold text-[#003460]">Service Hours</h4>
            {hoveredMarker.hours_of_service === "24x7" ? (
              <div className="text-left font-medium text-green-600">
                Open 24/7
              </div>
            ) : (
              <div className="rounded-lg bg-white shadow-sm">
                <table className="w-full border-collapse text-sm">
                  <tbody>
                    {(() => {
                      const days = [
                        "monday",
                        "tuesday",
                        "wednesday",
                        "thursday",
                        "friday",
                        "saturday",
                        "sunday",
                      ];
                      const groupedHours = {};

                      // Group days by their service hours
                      days.forEach((day) => {
                        const dayData = hoveredMarker.service_sched?.[day];
                        if (!dayData?.enabled) return;

                        const timeKey = `${dayData.start?.time} ${dayData.start?.period} - ${dayData.end?.time} ${dayData.end?.period}`;
                        if (!groupedHours[timeKey]) {
                          groupedHours[timeKey] = [];
                        }
                        groupedHours[timeKey].push(day);
                      });

                      // Render grouped days
                      return Object.entries(groupedHours).map(
                        ([hours, groupedDays]) => (
                          <tr key={hours}>
                            <td className="w-1/2 border-[1px] border-solid border-gray-300 px-2 py-1.5 font-medium text-[#242424]">
                              {groupedDays
                                .map(
                                  (day) =>
                                    day.charAt(0).toUpperCase() + day.slice(1)
                                )
                                .join(", ")}
                              :
                            </td>
                            <td className="w-1/2 bg-[#D3EBFF] px-2 py-1.5 text-[#242424]">
                              {hours}
                            </td>
                          </tr>
                        )
                      );
                    })()}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      );
    } else if (role === "citizen") {
      return null;
    } else {
      const fullAddress = `${hoveredMarker.address1 || ""} ${
        hoveredMarker.address2 || ""
      }, ${hoveredMarker.city || ""}, ${hoveredMarker.state || ""} ${
        hoveredMarker.zip || ""
      }`;
      return (
        <div
          className="flex flex-col gap-2 rounded-lg px-4 py-4"
          style={{ background: "white" }}
        >
          <div className="flex flex-col gap-2">
            <div className="flex flex-col gap-1 rounded-lg bg-[#003460] p-2">
              <h3 className="text-lg rounded-lg text-start font-semibold text-white">
                {hoveredMarker.name_of_hub || ""}
              </h3>
              <div className="text-gray-600 flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="#F6C46D"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-[#DCDCDC]">{fullAddress || ""}</span>
              </div>
              <div className="text-gray-600 flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="#F6C46D"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span className="text-[#DCDCDC]">
                  {hoveredMarker.contact_email || ""}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  // check if the text is overflowing to render "See more"
  const checkOverflow = (text) => {
    if (!text) return false;

    const tempDiv = document.createElement("div");
    tempDiv.style.cssText = `
    position: absolute;
    visibility: hidden;
    width: 380px;
    font-size: 14px;
    line-height: 1.5;
    padding: 0;
    margin: 0;
  `;
    tempDiv.innerText = text;
    document.body.appendChild(tempDiv);

    const hasOverflow = tempDiv.offsetHeight > 42;
    document.body.removeChild(tempDiv);

    return hasOverflow;
  };
  const filteredContacts = showCommunityContacts
    ? communityContacts.filter(
        (contact) =>
          (contact.Name || contact.name_of_org || "")
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          (contact.mobileNumber || contact.mobile_number || "")
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          (contact.email || "")
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
      )
    : partnerAreaServiced.filter(
        (partner) =>
          ((partner.name_of_org || "")
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
            (partner.mobileNumber || partner.contact_phone || "")
              .toLowerCase()
              .includes(searchQuery.toLowerCase()) ||
            (partner.contact_email || "")
              .toLowerCase()
              .includes(searchQuery.toLowerCase())) &&
          partner.is_certified !== false
      );

  const handleInfoMouseEnter = () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      setHideTimeout(null);
    }
  };

  const handleInfoMouseLeave = () => {
    setHoveredMarker(null);
    setMousePosition(null);
  };

  // Update the cleanup useEffect
  useEffect(() => {
    // Clear marker cache when component unmounts
    return () => setMarkerDataCache({});
  }, []);

  const getInfoPosition = (x, y) => {
    const padding = 20; // Padding from screen edges
    const infoWidth = 650; // Width of info window
    const infoMaxHeight = 450; // Max height of info window
    const leftNavWidth = 246; // Width of LeftNavPane (always present)
    const sidePanelWidth = showSidePanel ? 450 : 0;
    const minLeftPosition = leftNavWidth + (showSidePanel ? sidePanelWidth : 0);

    let translateX = "-50%"; // Default center alignment
    let leftPos = x;
    let arrowLeftPos = "50%"; // Default arrow position

    // First check if marker is too close to left nav/side panel
    if (x < minLeftPosition + infoWidth / 2) {
      // Position info window to start right after the nav/panel
      translateX = "0";
      leftPos = minLeftPosition + padding;
      arrowLeftPos = `${x - leftPos}px`;
    }
    // Then check if it's too close to right edge
    else if (x + infoWidth / 2 > window.innerWidth - padding) {
      translateX = "-100%";
      leftPos = window.innerWidth - padding;
      arrowLeftPos = `${x - (leftPos - infoWidth)}px`;
    } else {
      // Center position is fine
      leftPos = x;
    }

    // Calculate vertical position
    let topPos = y;
    let translateY = "20px"; // Default position below marker

    // If the info window would go below the viewport, show it above the marker
    if (y + infoMaxHeight + padding > window.innerHeight) {
      translateY = "-100%";
      topPos = y - 0;
    }

    return {
      infoStyle: {
        left: `${leftPos}px`,
        top: `${topPos}px`,
        transform: `translate(${translateX}, ${translateY})`,
        maxWidth: `${infoWidth}px`,
      },
      arrowStyle: {
        left: arrowLeftPos,
        transform: arrowLeftPos === "50%" ? "translateX(-50%)" : "none",
      },
    };
  };
  // Add this useEffect to check for overflow
  useEffect(() => {
    if (hoveredMarker) {
      // Check if content exceeds 2 rows AND there's more content to show
      const checkOverflow = (ref, items) => {
        if (ref.current) {
          const maxHeight = 64; // height for 2 rows
          return ref.current.scrollHeight > maxHeight && items?.length > 0;
        }
        return false;
      };

      setNeedsExpansion({
        donations: checkOverflow(
          donationTypesRef,
          hoveredMarker.donation_types
        ),
        items: checkOverflow(availableItemsRef, hoveredMarker.available_items),
        services: checkOverflow(
          servicesProvidedRef,
          hoveredMarker.servicesProvided
        ),
      });
    }
  }, [hoveredMarker]);

  return (
    <div className="relative h-[calc(100vh-64px)] w-full ">
      {/* Side Panel (Now on the Left) */}
      <div className="relative">
        <div
          className={`absolute left-0 top-0 z-10 w-[450px] transform bg-white shadow-lg transition-transform ${
            showSidePanel ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="h-[calc(100vh-64px)] bg-white  p-2">
            <input
              type="text"
              placeholder="Search a contact"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="font-Inter mt-4 w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-[#467BA4] focus:outline-none"
            />

            {/* Toggle Button */}
            {/* {role === "citizen" && (
              <div className="mx-auto my-3 flex w-full justify-center gap-4 ">
                <button
                  className={`flex w-1/2 items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm hover:cursor-pointer ${
                    showCommunityContacts
                      ? "bg-[#1C82D8] text-white"
                      : "bg-gray-200"
                  }`}
                  onClick={() => setShowCommunityContacts(true)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_10124_11426"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_10124_11426)">
                      <path
                        d="M1 18C0.716667 18 0.479167 17.9042 0.2875 17.7125C0.0958333 17.5208 0 17.2833 0 17V16.425C0 15.7083 0.366667 15.125 1.1 14.675C1.83333 14.225 2.8 14 4 14C4.21667 14 4.425 14.0042 4.625 14.0125C4.825 14.0208 5.01667 14.0417 5.2 14.075C4.96667 14.425 4.79167 14.7917 4.675 15.175C4.55833 15.5583 4.5 15.9583 4.5 16.375V18H1ZM7 18C6.71667 18 6.47917 17.9042 6.2875 17.7125C6.09583 17.5208 6 17.2833 6 17V16.375C6 15.8417 6.14583 15.3542 6.4375 14.9125C6.72917 14.4708 7.14167 14.0833 7.675 13.75C8.20833 13.4167 8.84583 13.1667 9.5875 13C10.3292 12.8333 11.1333 12.75 12 12.75C12.8833 12.75 13.6958 12.8333 14.4375 13C15.1792 13.1667 15.8167 13.4167 16.35 13.75C16.8833 14.0833 17.2917 14.4708 17.575 14.9125C17.8583 15.3542 18 15.8417 18 16.375V17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5208 17.9042 17.2833 18 17 18H7ZM19.5 18V16.375C19.5 15.9417 19.4458 15.5333 19.3375 15.15C19.2292 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.2208 14.0208 19.4125 14.0125C19.6042 14.0042 19.8 14 20 14C21.2 14 22.1667 14.2208 22.9 14.6625C23.6333 15.1042 24 15.6917 24 16.425V17C24 17.2833 23.9042 17.5208 23.7125 17.7125C23.5208 17.9042 23.2833 18 23 18H19.5ZM4 13C3.45 13 2.97917 12.8042 2.5875 12.4125C2.19583 12.0208 2 11.55 2 11C2 10.4333 2.19583 9.95833 2.5875 9.575C2.97917 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0208 5.425 12.4125C5.04167 12.8042 4.56667 13 4 13ZM20 13C19.45 13 18.9792 12.8042 18.5875 12.4125C18.1958 12.0208 18 11.55 18 11C18 10.4333 18.1958 9.95833 18.5875 9.575C18.9792 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0208 21.425 12.4125C21.0417 12.8042 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.4375 9.875 6.8625C10.4583 6.2875 11.1667 6 12 6C12.85 6 13.5625 6.2875 14.1375 6.8625C14.7125 7.4375 15 8.15 15 9C15 9.83333 14.7125 10.5417 14.1375 11.125C13.5625 11.7083 12.85 12 12 12Z"
                        fill={showCommunityContacts ? "#ffffff" : "#003460"}
                      />
                    </g>
                  </svg>
                  <p className="text-sm">Community</p>
                </button>
                <button
                  className={`flex w-1/2 items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm hover:cursor-pointer ${
                    !showCommunityContacts
                      ? "bg-[#1C82D8] text-white"
                      : "bg-gray-200"
                  }`}
                  onClick={() => setShowCommunityContacts(false)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_10124_11432"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_10124_11432)">
                      <path
                        d="M12.1002 21.0008C11.8169 21.0008 11.5794 20.9049 11.3877 20.7133C11.196 20.5216 11.1002 20.2841 11.1002 20.0008C11.1002 19.8841 11.1252 19.7633 11.1752 19.6383C11.2252 19.5133 11.3002 19.4008 11.4002 19.3008L15.6752 15.0258C15.7752 14.9258 15.8252 14.8049 15.8252 14.6633C15.8252 14.5216 15.7752 14.4008 15.6752 14.3008C15.5752 14.2008 15.4544 14.1549 15.3127 14.1633C15.171 14.1716 15.0502 14.2258 14.9502 14.3258L10.7002 18.5758C10.6002 18.6758 10.4919 18.7508 10.3752 18.8008C10.2585 18.8508 10.1335 18.8758 10.0002 18.8758C9.71686 18.8758 9.47936 18.7799 9.2877 18.5883C9.09603 18.3966 9.0002 18.1591 9.0002 17.8758C9.0002 17.7091 9.0252 17.5716 9.0752 17.4633C9.1252 17.3549 9.19186 17.2591 9.2752 17.1758L13.5502 12.9008C13.6502 12.8008 13.7002 12.6841 13.7002 12.5508C13.7002 12.4174 13.6502 12.3008 13.5502 12.2008C13.4502 12.1008 13.3335 12.0508 13.2002 12.0508C13.0669 12.0508 12.9502 12.1008 12.8502 12.2008L8.5752 16.4508C8.4752 16.5508 8.36686 16.6258 8.2502 16.6758C8.13353 16.7258 8.0002 16.7508 7.8502 16.7508C7.58353 16.7508 7.3502 16.6508 7.1502 16.4508C6.9502 16.2508 6.8502 16.0174 6.8502 15.7508C6.8502 15.6174 6.8752 15.4924 6.9252 15.3758C6.9752 15.2591 7.0502 15.1508 7.1502 15.0508L11.4002 10.8008C11.5002 10.7008 11.5502 10.5799 11.5502 10.4383C11.5502 10.2966 11.5002 10.1758 11.4002 10.0758C11.3002 9.97578 11.1835 9.92578 11.0502 9.92578C10.9169 9.92578 10.8002 9.97578 10.7002 10.0758L6.4502 14.3508C6.36686 14.4341 6.26686 14.5008 6.1502 14.5508C6.03353 14.6008 5.89186 14.6258 5.7252 14.6258C5.44186 14.6258 5.20436 14.5299 5.0127 14.3383C4.82103 14.1466 4.7252 13.9091 4.7252 13.6258C4.7252 13.4924 4.7502 13.3674 4.8002 13.2508C4.8502 13.1341 4.9252 13.0258 5.0252 12.9258L9.9252 8.02578C10.1085 7.84245 10.3377 7.75911 10.6127 7.77578C10.8877 7.79245 11.1169 7.89245 11.3002 8.07578L14.3502 11.1258C14.5335 11.3091 14.7502 11.4549 15.0002 11.5633C15.2502 11.6716 15.5002 11.7258 15.7502 11.7258C16.2835 11.7258 16.7502 11.5383 17.1502 11.1633C17.5502 10.7883 17.7502 10.3091 17.7502 9.72578C17.7502 9.49245 17.7085 9.25078 17.6252 9.00078C17.5419 8.75078 17.3919 8.51745 17.1752 8.30078L13.7502 4.87578C13.5669 4.69245 13.446 4.49245 13.3877 4.27578C13.3294 4.05911 13.3585 3.85078 13.4752 3.65078C13.6252 3.40078 13.8169 3.21745 14.0502 3.10078C14.2835 2.98411 14.5419 2.92578 14.8252 2.92578C15.1752 2.92578 15.5335 3.00911 15.9002 3.17578C16.2669 3.34245 16.6002 3.57578 16.9002 3.87578L21.1252 8.12578C21.4252 8.42578 21.646 8.75911 21.7877 9.12578C21.9294 9.49245 22.0002 9.91745 22.0002 10.4008C22.0002 10.7341 21.9252 11.0716 21.7752 11.4133C21.6252 11.7549 21.4085 12.0674 21.1252 12.3508L12.8002 20.7008C12.6669 20.8341 12.5502 20.9174 12.4502 20.9508C12.3502 20.9841 12.2335 21.0008 12.1002 21.0008ZM2.9002 12.1258C2.58353 11.8924 2.34603 11.6133 2.1877 11.2883C2.02936 10.9633 1.9502 10.6174 1.9502 10.2508C1.9502 9.86745 2.02936 9.49245 2.1877 9.12578C2.34603 8.75911 2.5752 8.42578 2.8752 8.12578L7.1002 3.87578C7.38353 3.59245 7.69603 3.37578 8.0377 3.22578C8.37936 3.07578 8.74186 3.00078 9.1252 3.00078C9.54186 3.00078 9.94603 3.07578 10.3377 3.22578C10.7294 3.37578 11.0669 3.59245 11.3502 3.87578L16.4752 9.00078C16.5585 9.08411 16.6294 9.18828 16.6877 9.31328C16.746 9.43828 16.7752 9.56745 16.7752 9.70078C16.7752 9.98411 16.6794 10.2216 16.4877 10.4133C16.296 10.6049 16.0585 10.7008 15.7752 10.7008C15.6419 10.7008 15.5127 10.6716 15.3877 10.6133C15.2627 10.5549 15.1585 10.4841 15.0752 10.4008L12.0002 7.35078C11.6169 6.96745 11.146 6.77578 10.5877 6.77578C10.0294 6.77578 9.55853 6.96745 9.1752 7.35078L4.4752 12.0508C4.25853 12.2674 4.00436 12.3799 3.7127 12.3883C3.42103 12.3966 3.1502 12.3091 2.9002 12.1258Z"
                        fill={showCommunityContacts ? "#242424" : "#FFFFFF"}
                      />
                    </g>
                  </svg>
                  Partners
                </button>
              </div>
            )} */}

            <div
              className={`mt-2  overflow-y-auto ${
                role === "citizen"
                  ? "h-[calc(100vh-140px)]"
                  : "h-[calc(100vh-140px)]"
              }`}
            >
              <div>
                {filteredContacts.length > 0 ? (
                  filteredContacts.map((contact, index) => {
                    // Pre-calculate the text content for each section
                    const donationsText =
                      contact.donation_types &&
                      contact.accept_donations === "yes"
                        ? contact.donation_types
                            .map((type) =>
                              type === "other"
                                ? contact.other_donation_types || ""
                                : type.charAt(0).toUpperCase() + type.slice(1)
                            )
                            .join(", ")
                        : "";

                    const itemsText = contact.available_items
                      ? contact.available_items
                          .map((item) =>
                            item === "other"
                              ? contact.other_items || ""
                              : item.charAt(0).toUpperCase() + item.slice(1)
                          )
                          .join(", ")
                      : "";

                    const servicesText = contact.servicesProvided
                      ? contact.servicesProvided
                          .map((service) =>
                            service === "other"
                              ? contact.other_services || ""
                              : service.charAt(0).toUpperCase() +
                                service.slice(1)
                          )
                          .join(", ")
                      : "";

                    // Check for overflow
                    const hasDonationsOverflow = checkOverflow(donationsText);
                    const hasItemsOverflow = checkOverflow(itemsText);
                    const hasServicesOverflow = checkOverflow(servicesText);

                    return (
                      <div
                        key={contact.id || index}
                        className="border-1 mb-2 mr-2 rounded-lg border border-[#1C82D8] bg-[#FAFAFA] p-3 shadow-[2px_2px_4px_2px_rgba(0,0,0,0.2)]"
                      >
                        <p className="font-semibold text-[#414141]">
                          {contact.Name || contact.name_of_org || ""}
                        </p>
                        {contact.occupation && (
                          <div className="mt-1 flex items-center gap-2 text-sm text-[#414141]">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_10124_11438"
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="white" />
                              </mask>
                              <g mask="url(#mask0_10124_11438)">
                                <path
                                  d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM10 6H14V4H10V6Z"
                                  fill="#1C82D8"
                                />
                              </g>
                            </svg>
                            <p className="-ml-1 text-sm text-[#414141]">
                              {contact.occupation}
                            </p>
                          </div>
                        )}

                        {!contact.occupation && (
                          <div className="mt-1 flex items-center gap-2 text-sm text-[#414141] ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                              fill="#1C82D8"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                clipRule="evenodd"
                              />
                            </svg>
                            <p className="text-sm">
                              {contact.address1
                                ? `${contact.address1}${
                                    contact.address2
                                      ? `, ${contact.address2}`
                                      : ""
                                  }, ${contact.city || ""}, ${
                                    contact.state || ""
                                  } ${contact.zip || ""}`
                                : ""}
                            </p>
                          </div>
                        )}
                        {contact.occupation && contact.mobileNumber && (
                          <div className="mt-1 flex items-center gap-2 text-sm text-[#414141] ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                              fill="#1C82D8"
                            >
                              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            <p className="text-sm">
                              {contact.mobileNumber || ""}
                            </p>
                          </div>
                        )}
                        {!contact.occupation && contact.contact_phone && (
                          <div className="mt-1 flex items-center gap-2 text-sm text-[#414141] ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                              fill="#1C82D8"
                            >
                              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            <p className="text-sm">
                              {contact.contact_phone || ""}
                            </p>
                          </div>
                        )}
                        {contact.occupation && contact.email && (
                          <div className="flex items-center gap-2 text-sm text-[#414141]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                              fill="#1C82D8"
                            >
                              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            <p className="text-sm">{contact.email || ""}</p>
                          </div>
                        )}
                        {!contact.occupation && contact.contact_email && (
                          <div className="flex items-center gap-2 text-sm text-[#414141]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                              fill="#1C82D8"
                            >
                              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            <p className="text-sm">
                              {contact.contact_email || ""}
                            </p>
                          </div>
                        )}

                        {/* Donation Types */}
                        {contact.donation_types &&
                          contact.accept_donations === "yes" && (
                            <div className="my-2">
                              <p className="mt-2 font-semibold text-[#414141]">
                                Donations Accepted:
                              </p>
                              <div
                                className={`transition-all duration-300 ${
                                  !expandedSections.donations[contact.id]
                                    ? "max-h-[40px]"
                                    : ""
                                } overflow-hidden`}
                              >
                                <span className="text-sm text-[#414141]">
                                  {donationsText}
                                </span>
                              </div>
                              {hasDonationsOverflow && (
                                <button
                                  onClick={() =>
                                    setExpandedSections((prev) => ({
                                      ...prev,
                                      donations: {
                                        ...prev.donations,
                                        [contact.id]:
                                          !prev.donations[contact.id],
                                      },
                                    }))
                                  }
                                  className="bg-transparent text-sm font-semibold text-[#1C82D8] hover:cursor-pointer"
                                >
                                  {expandedSections.donations[contact.id]
                                    ? "See less"
                                    : "See more"}
                                </button>
                              )}
                            </div>
                          )}

                        {/* Available Items */}
                        {contact.available_items && (
                          <div className="my-2">
                            <p className="mt-2 font-semibold text-[#414141]">
                              Available Items:
                            </p>
                            <div
                              className={`transition-all duration-300 ${
                                !expandedSections.items[contact.id]
                                  ? "max-h-[40px]"
                                  : ""
                              } overflow-hidden`}
                            >
                              <span className="text-sm text-[#414141]">
                                {itemsText}
                              </span>
                            </div>
                            {hasItemsOverflow && (
                              <button
                                onClick={() =>
                                  setExpandedSections((prev) => ({
                                    ...prev,
                                    items: {
                                      ...prev.items,
                                      [contact.id]: !prev.items[contact.id],
                                    },
                                  }))
                                }
                                className="bg-transparent text-sm font-semibold text-[#1C82D8] hover:cursor-pointer"
                              >
                                {expandedSections.items[contact.id]
                                  ? "See less"
                                  : "See more"}
                              </button>
                            )}
                          </div>
                        )}

                        {/* Services Provided */}
                        {contact.servicesProvided && (
                          <div className="my-2">
                            <p className="mt-2 font-semibold text-[#414141]">
                              Services Provided:
                            </p>
                            <div
                              className={`transition-all duration-300 ${
                                !expandedSections.services[contact.id]
                                  ? "max-h-[40px]"
                                  : ""
                              } overflow-hidden`}
                            >
                              <span className="text-sm text-[#414141]">
                                {servicesText}
                              </span>
                            </div>
                            {hasServicesOverflow && (
                              <button
                                onClick={() =>
                                  setExpandedSections((prev) => ({
                                    ...prev,
                                    services: {
                                      ...prev.services,
                                      [contact.id]: !prev.services[contact.id],
                                    },
                                  }))
                                }
                                className="bg-transparent text-sm font-semibold text-[#1C82D8] hover:cursor-pointer"
                              >
                                {expandedSections.services[contact.id]
                                  ? "See less"
                                  : "See more"}
                              </button>
                            )}
                          </div>
                        )}

                        {/* Service Hours */}
                        {contact.hours_of_service && (
                          <div className="bg-gray-50">
                            {contact.hours_of_service === "24x7" ? (
                              <div className="flex items-center gap-1 text-left text-sm text-green-600">
                                Open 24/7
                              </div>
                            ) : (
                              <div className="rounded-lg bg-white shadow-sm">
                                <p className="mt-2 font-semibold text-[#414141]">
                                  Service Hours:
                                </p>
                                <table className="w-full text-sm">
                                  <tbody>
                                    {(() => {
                                      const days = [
                                        "monday",
                                        "tuesday",
                                        "wednesday",
                                        "thursday",
                                        "friday",
                                        "saturday",
                                        "sunday",
                                      ];
                                      const groupedHours = {};

                                      // Group days by their service hours
                                      days.forEach((day) => {
                                        const dayData =
                                          contact.service_sched?.[day];
                                        if (!dayData?.enabled) return;

                                        const timeKey = `${dayData.start?.time} ${dayData.start?.period} - ${dayData.end?.time} ${dayData.end?.period}`;
                                        if (!groupedHours[timeKey]) {
                                          groupedHours[timeKey] = [];
                                        }
                                        groupedHours[timeKey].push(day);
                                      });

                                      // Render grouped days
                                      return Object.entries(groupedHours).map(
                                        ([hours, groupedDays]) => (
                                          <tr key={hours}>
                                            <td className="w-1/2 border-[1px] border-solid border-gray-300 px-2 py-1.5 font-medium text-[#242424]">
                                              {groupedDays
                                                .map(
                                                  (day) =>
                                                    day
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    day.slice(1)
                                                )
                                                .join(", ")}
                                              :
                                            </td>
                                            <td className="w-1/2 bg-[#D3EBFF] px-2 py-1.5 text-[#242424]">
                                              {hours}
                                            </td>
                                          </tr>
                                        )
                                      );
                                    })()}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center text-gray-500">
                    No matching contacts found
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Toggle Button (Now on the Left) */}
        <div
          className={`absolute left-0 top-0 z-10 mt-[50vh] h-full w-8 transform cursor-pointer bg-white shadow-lg transition-transform ${
            showSidePanel ? "translate-x-[450px]" : "ml-0 -translate-x-0"
          }`}
          onClick={() => setShowSidePanel(!showSidePanel)}
        >
          <div className="rounded-r border-b border-r border-t border-solid border-gray-400 bg-white p-2">
            {showSidePanel ? "❮" : "❯"}
          </div>
        </div>
      </div>

      <APIProvider apiKey={config.google_maps}>
        <VISGoogleMap
          key={
            coordinates
              ? `${coordinates.lat}-${coordinates.lon}`
              : "default-map"
          }
          defaultZoom={coordinates ? 15 : 4} // Adjust zoom level based on coordinates existence
          defaultCenter={
            coordinates
              ? { lat: coordinates.lat, lng: coordinates.lon }
              : { lat: 39.8, lng: -98.57 } // Center of the US
          }
          options={{
            disableDefaultUI: true,
            gestureHandling: "greedy",
            styles: [
              { featureType: "poi", stylers: [{ visibility: "off" }] },
              { featureType: "transit", stylers: [{ visibility: "off" }] },
              // {
              //   featureType: "road",
              //   elementType: "labels",
              //   stylers: [{ visibility: "off" }],
              // },
            ],

            mapTypeControl: true,
            mapTypeControlOptions: {
              position: window.google?.maps?.ControlPosition?.TOP_LEFT,
              style: window.google?.maps?.MapTypeControlStyle?.HORIZONTAL_BAR,
              mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain"],
            },
            fullscreenControl: true,
            streetViewControl: true,
            scaleControl: true,
            zoomControl: true,
            rotateControl: true,
            controlSize: 28,
            streetView: {
              visible: true,
              enableCloseButton: true,
              motionTracking: false,
            },
          }}
          ref={mapRef}
          onLoad={handleMapLoad}
        >
          {/* Render current user marker */}
          {coordinates && coordinates.lat && coordinates.lon && role && (
            <CustomMarkerWithLabel
              position={{ lat: coordinates.lat, lng: coordinates.lon }}
              icon={getMarkerImage(role, true)}
              label={"You"}
              onMouseOver={(event) => handleMarkerHover(data, event)}
              onMouseOut={handleMarkerLeave}
              role={"current_user"}
            />
          )}

          {/* Render related users with the same center_id */}
          {relatedUsers
            .filter(
              (user, index, self) =>
                user.id !== userId &&
                !(
                  user.latitude === coordinates?.lat &&
                  user.longitude === coordinates?.lon
                ) &&
                index === self.findIndex((t) => t.id === user.id) &&
                user.latitude != null &&
                user.longitude != null
            )
            .map((user) => {
              const role = user.user_role || user.userType?.toLowerCase();
              const labelText =
                role === "center"
                  ? user.name_of_hub
                    ? `${user.name_of_hub}`
                    : "No Hub Name"
                  : role === "partner"
                  ? user.name_of_org
                    ? `${user.name_of_org}`
                    : "No Org Name"
                  : user.name || " ";

              const markerIcon = getMarkerImage(role, false);

              return (
                <StreetViewMarker
                  key={user.id}
                  position={{ lat: user.latitude, lng: user.longitude }}
                  icon={markerIcon}
                  label={labelText}
                  onMouseOver={(event) => handleMarkerHover(user, event)}
                  onMouseOut={handleMarkerLeave}
                  role={role}
                />
              );
            })}

          {/* Update info window to handle hover */}
          {hoveredMarker &&
            hoveredMarker.user_role !== "citizen" &&
            mousePosition && (
              <div
                style={{
                  position: "fixed",
                  backgroundColor: "white",
                  borderRadius: "8px",
                  boxShadow: "12px 12px 60px rgba(0,0,0,0.8)",
                  zIndex: 1000,
                  width: "650px",
                  maxHeight: "450px",
                  opacity: 1,
                  transition: "all 0.15s ease-out",
                  willChange: "transform, opacity, left",
                  overflow: "hidden",
                  ...getInfoPosition(mousePosition.x, mousePosition.y)
                    .infoStyle,
                }}
                className="relative hover:cursor-default"
                onMouseEnter={handleInfoMouseEnter}
                onMouseLeave={handleInfoMouseLeave}
              >
                {/* Add invisible buffer zone */}
                <div
                  style={{
                    position: "absolute",
                    top:
                      mousePosition.y > window.innerHeight / 2
                        ? "100%"
                        : "-20px",
                    left: 0,
                    width: "100%",
                    height: "20px",
                  }}
                  onMouseEnter={handleInfoMouseEnter}
                />

                {/* Arrow with dynamic positioning */}
                <div
                  style={{
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    [mousePosition.y > window.innerHeight / 2
                      ? "bottom"
                      : "top"]: "-20px",
                    width: "30px",
                    height: "20px",
                    background: "#1387EA",
                    clipPath:
                      mousePosition.y > window.innerHeight / 2
                        ? "polygon(50% 100%, 0 0, 100% 0)"
                        : "polygon(50% 0, 0 100%, 100% 100%)",
                    zIndex: 9999,
                    pointerEvents: "none",
                  }}
                />

                {/* Content container */}
                <div
                  className="relative z-10 overflow-y-auto"
                  style={{
                    maxHeight: "calc(450px - 24px)",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#808080 white", // Gray scrollbar with white background
                    boxShadow: "inset 0 12px 24px -12px rgba(0,0,0,0.5)",
                  }}
                >
                  {renderMarkerInfo()}
                </div>
              </div>
            )}
        </VISGoogleMap>
      </APIProvider>
    </div>
  );
};

export default Map;
